import React, { createContext, useContext, useState, useEffect } from "react"
import { getCookieConsentValue } from "react-cookie-consent"

const ProfileContext = createContext(undefined)

export const ProfileContextProvider = ({ children }) => {
    const [hasAllowedCookies, setHasAllowedCookies] = useState(() => {
        return getCookieConsentValue("profileData") === "true"
    })

    useEffect(() => {
        if (!hasAllowedCookies) localStorage.clear()
    }, [hasAllowedCookies])

    const [favorites, setFavorites] = useState(() => {
        const savedFavorites = hasAllowedCookies
            ? localStorage.getItem("favorites")
            : null

        return savedFavorites ? JSON.parse(savedFavorites) : []
    })

    const [profileData, setProfileData] = useState(() => {
        const savedProfileData = hasAllowedCookies
            ? localStorage.getItem("profileData")
            : null
        return savedProfileData ? JSON.parse(savedProfileData) : {}
    })

    const [hasOnboarded, setHasOnboarded] = useState(() => {
        const savedHasOnboarded = hasAllowedCookies
            ? localStorage.getItem("hasOnboarded")
            : "false"
        return savedHasOnboarded === "true"
    })

    useEffect(() => {
        if (hasAllowedCookies)
            localStorage.setItem("favorites", JSON.stringify(favorites))
    }, [favorites, hasAllowedCookies])

    useEffect(() => {
        if (hasAllowedCookies)
            localStorage.setItem("profileData", JSON.stringify(profileData))
    }, [profileData, hasAllowedCookies])

    useEffect(() => {
        if (hasAllowedCookies)
            localStorage.setItem("hasOnboarded", hasOnboarded.toString())
    }, [hasOnboarded, hasAllowedCookies])

    useEffect(() => {
        if (!hasAllowedCookies) {
            localStorage.clear()
        }
    }, [hasAllowedCookies])

    const contextSetHasOnBoarded = (val) => {
        if (typeof val != "boolean") {
            return
        }
        setHasOnboarded(val)
    }

    const contextSetProfileData = (obj = {}) => {
        setProfileData(obj)
        setHasOnboarded(true)
    }

    const contextSetFavorites = (item) => {
        setFavorites((prevFavorites) => {
            // kontrollera så att det blir inga dubbletter
            if (
                prevFavorites.some(
                    (fav) => fav.monternummer === item.monternummer,
                )
            ) {
                return prevFavorites.filter(
                    (fav) => fav.monternummer !== item.monternummer,
                )
            } else {
                return [...prevFavorites, item]
            }
        })
    }

    const contextClearFavorites = () => {
        setFavorites([])
    }

    const contextSetHasAllowedCookies = (hasAllowed) => {
        setHasAllowedCookies(hasAllowed)
    }

    return (
        <ProfileContext.Provider
            value={{
                favorites,
                profileData,
                hasOnboarded,
                hasAllowedCookies,
                contextSetFavorites,
                contextSetProfileData,
                contextSetHasOnBoarded,
                contextSetHasAllowedCookies,
                contextClearFavorites,
            }}
        >
            {children}
        </ProfileContext.Provider>
    )
}

export const useProfile = () => {
    const context = useContext(ProfileContext)
    if (context === undefined)
        throw new Error(
            "useProfile must be used within a ProfileContextProvider",
        )
    return context
}
